module.exports = __webpack_public_path__ + "static/img/6.d7ef745.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/6.png
// module id = vI/+
// module chunks = 0